module.exports = __webpack_public_path__ + "static/email-design-dots-1-8d24986e8709ab054b4558fa6550c503.svg";